module.exports = __webpack_public_path__ + "static/media/urbangoo10.661a0d0f.webp";